var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7083 24.5418L47.0416 66.2085C45.4166 67.8335 42.7916 67.8335 41.1666 66.2085L29.3749 54.4168C27.7499 52.7918 27.7499 50.1668 29.3749 48.5418C30.9999 46.9168 33.6249 46.9168 35.2499 48.5418L44.0833 57.3751L82.7916 18.6668C84.4166 17.0418 87.0416 17.0418 88.6666 18.6668C90.3333 20.2918 90.3333 22.9168 88.7083 24.5418ZM49.9999 83.3335C30.3749 83.3335 14.6666 66.2918 16.8749 46.2501C18.4999 31.5835 29.8749 19.5418 44.4166 17.1251C51.9583 15.8751 59.1249 17.2085 65.2083 20.3751C66.8333 21.2085 68.7916 20.9168 70.0833 19.6251C72.0833 17.6251 71.5833 14.2501 69.0833 12.9585C62.9583 9.83347 56.0416 8.12514 48.6666 8.33347C27.2499 9.00014 9.45828 26.4168 8.37494 47.7918C7.16661 71.8335 26.2499 91.6668 49.9999 91.6668C54.9999 91.6668 59.7499 90.7918 64.2083 89.1668C67.0416 88.1251 67.8333 84.4585 65.6666 82.2918C64.5416 81.1668 62.8333 80.7501 61.3333 81.3335C57.7916 82.6251 53.9583 83.3335 49.9999 83.3335ZM79.1666 62.5001H70.8333C68.5416 62.5001 66.6666 64.3751 66.6666 66.6668C66.6666 68.9585 68.5416 70.8335 70.8333 70.8335H79.1666V79.1668C79.1666 81.4585 81.0416 83.3335 83.3333 83.3335C85.6249 83.3335 87.4999 81.4585 87.4999 79.1668V70.8335H95.8333C98.1249 70.8335 99.9999 68.9585 99.9999 66.6668C99.9999 64.3751 98.1249 62.5001 95.8333 62.5001H87.4999V54.1668C87.4999 51.8751 85.6249 50.0001 83.3333 50.0001C81.0416 50.0001 79.1666 51.8751 79.1666 54.1668V62.5001Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTask);
export default __webpack_public_path__ + "static/media/add_task.55ae829c0fe5903c9cf09cdf42211be6.svg";
export { ForwardRef as ReactComponent };